import React from 'react';
import { Box, Button, Stack, IconButton } from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import ReplayIcon from '@mui/icons-material/Replay';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';

const GameControls = ({
  status,
  onStart,
  onPause,
  onResume,
  onReset,
  onMoveLeft,
  onMoveRight,
  onMoveDown,
  onRotate,
  onHardDrop,
  showMobile = false,
}) => {
  const renderMainButton = () => {
    switch (status) {
    case 'idle':
      return (
        <Button
          variant="contained"
          size="large"
          startIcon={<PlayArrowIcon />}
          onClick={onStart}
          fullWidth
        >
          Start
        </Button>
      );
    case 'playing':
      return (
        <Stack direction="row" spacing={1}>
          <Button
            variant="outlined"
            startIcon={<PauseIcon />}
            onClick={onPause}
            fullWidth
          >
            Pause
          </Button>
          <IconButton onClick={onReset} color="warning" size="small">
            <ReplayIcon />
          </IconButton>
        </Stack>
      );
    case 'paused':
      return (
        <Stack direction="row" spacing={1}>
          <Button
            variant="contained"
            startIcon={<PlayArrowIcon />}
            onClick={onResume}
            fullWidth
          >
            Resume
          </Button>
          <IconButton onClick={onReset} color="warning" size="small">
            <ReplayIcon />
          </IconButton>
        </Stack>
      );
    case 'gameover':
      return (
        <Button
          variant="contained"
          startIcon={<ReplayIcon />}
          onClick={onReset}
          fullWidth
        >
          Play Again
        </Button>
      );
    default:
      return null;
    }
  };

  return (
    <Box sx={{ mt: 2 }}>
      {renderMainButton()}

      {showMobile && status === 'playing' && (
        <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
          <IconButton onClick={onRotate} sx={{ bgcolor: 'action.hover' }}>
            <KeyboardArrowUpIcon />
          </IconButton>
          <Stack direction="row" spacing={1}>
            <IconButton onClick={onMoveLeft} sx={{ bgcolor: 'action.hover' }}>
              <KeyboardArrowLeftIcon />
            </IconButton>
            <IconButton onClick={onHardDrop} sx={{ bgcolor: 'action.hover' }}>
              <KeyboardDoubleArrowDownIcon />
            </IconButton>
            <IconButton onClick={onMoveRight} sx={{ bgcolor: 'action.hover' }}>
              <KeyboardArrowRightIcon />
            </IconButton>
          </Stack>
          <IconButton onClick={onMoveDown} sx={{ bgcolor: 'action.hover' }}>
            <KeyboardArrowDownIcon />
          </IconButton>
        </Box>
      )}
    </Box>
  );
};

export default GameControls;
